import {
    Box,
    Stack,
    SimpleGrid,
    Flex,
    Circle,
    Heading,
    Center,
    Text,
    HStack,
    Avatar,
    Icon,
    GridItem,
} from "@chakra-ui/react";
import { HiLocationMarker } from "react-icons/hi";
import { Link } from "react-router-dom";

const ListHeader = ({ children }) => {
    return (
        <Heading color="pink" fontSize={"2xl"} mb={2}>
            {children}
        </Heading>
    );
};

function LocationLocal({ text }) {
    return (
        <Flex>
            <Icon pe={2} fontSize="4xl" color="pink" as={HiLocationMarker} />
            <Text fontSize="xl">{text}</Text>
        </Flex>
    );
}

export default function Footer({ footer, contact }) {
    return (
        <Box pt={8} mt="0px !important" bgColor="rgba(255,255,255,.1)">
            <Center>
                <SimpleGrid
                    w={["90%", "80%"]}
                    columns={{ base: 1, md: 3 }}
                    gap={10}
                >
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Stack spacing={6}>
                            <Heading color="pink" fontSize={"3xl"}>
                                {footer[0].value}
                            </Heading>
                            <Link to="/contact">
                                <Stack>
                                    <Heading color="pink" fontSize={"2xl"}>
                                        Address
                                    </Heading>
                                    {JSON.parse(contact[2].value).map((a, index) => (
                                        <LocationLocal
                                            key={index}
                                            text={a.address}
                                        />
                                    ))}
                                </Stack>
                            </Link>
                            <Stack>
                                <Stack>
                                    <Text fontSize="xl">Founded by</Text>
                                    <Heading fontSize="2xl" color="biruMuda">
                                        {footer[1].value}
                                    </Heading>
                                </Stack>
                                <Heading fontSize="2xl">
                                    {footer[2].value}
                                </Heading>
                            </Stack>
                        </Stack>
                    </GridItem>
                    <Stack align={"flex-start"}>
                        <ListHeader>Social Media</ListHeader>
                        {JSON.parse(contact[1].value).map((c) => (
                            <a
                                target="blank"
                                key={c.link}
                                href={c.link}
                            >
                                <HStack>
                                    <Avatar p={2} src={process.env.REACT_APP_IMAGE_URL + c.icon} />
                                    <Text fontSize="xl">{c.text}</Text>
                                </HStack>
                            </a>
                        ))}
                    </Stack>
                </SimpleGrid>
            </Center>
            <Box pb={4}>
                <Flex
                    align={"center"}
                    _before={{
                        content: '""',
                        borderBottom: "3px solid",
                        borderColor: "pink",
                        flexGrow: 1,
                        mr: 4,
                    }}
                    _after={{
                        content: '""',
                        borderBottom: "3px solid",
                        borderColor: "pink",
                        flexGrow: 1,
                        ml: 4,
                    }}
                >
                    <Circle bgColor="white" p={2} w={20}>
                        <img alt="" src="/logo.png" />
                    </Circle>
                </Flex>
            </Box>
        </Box>
    );
}
